<div [ngStyle]="{ width: size + 'px', height: size + 'px' }" class="db-waiting-spinner" [ngClass]="{ 'db-waiting-spinner_centered': centered }">
  <span class="db-waiting-spinner__spinner"></span>
</div>
